import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentWrapper from "../../../Wrapper";
import * as accountUserActions from "../../store/actions/account_users_actions";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import { ContentWithCardLoading } from "../../../../components/loading";
import AccountDetailsSubheader from "../../components/account-details-subheader";

export default function AccountUser({ match }) {
  const tabName = "Team Members";
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const accountUsers = useSelector((state) => state.accounts.accountUsers);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountUserActions.getListOfUsersRequest({ accountId: match.params.accountId }));
  }, [dispatch, match.params.accountId]);

  return (
    <ContentWrapper subHeader={<AccountDetailsSubheader active={tabName} />}>
      {accountUsers.loading ? (
        <ContentWithCardLoading />
      ) : accountUsers.data.length === 0 ? (
        "No accounts"
      ) : (
        // <CustomEmptyPage
        //   page="blockContact"
        //   setShowAdd={() => {
        //     setShow(true);
        //     setIsEdit(false);
        //   }}
        // />
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Full Name", apiKeyName: "fullName", fieldInputType: "INPUT" },
                { title: "Email", apiKeyName: "email", fieldInputType: "INPUT" },
                { title: "User Type", apiKeyName: "userType", fieldInputType: "INPUT" },
                { title: "Phone", apiKeyName: "phone", fieldInputType: "INPUT" },
                { title: "User status", apiKeyName: "userStatus", fieldInputType: "INPUT" },
                { title: "Is Verified", apiKeyName: "isVerified", fieldInputType: "TOGGLE_BUTTON" },
                { title: "Is Google User", apiKeyName: "isGoogleVerified", fieldInputType: "TOGGLE_BUTTON" },
                { title: "Is Deactivated", apiKeyName: "isDeactivated", fieldInputType: "TOGGLE_BUTTON" },
              ]}
              data={accountUsers.data}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={setPageNo}
              count={accountUsers.Count}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
}
